import useSWR from 'swr';

type UptimeDailyEntry = {
  date: string;
  uptime_percentage: number;
};

type UptimeResponse = {
  daily: UptimeDailyEntry[];
  six_month_uptime: {
    uptime_percentage: number;
  };
};

export function useUptime(region: string) {
  const endpoint =
    region === 'eu'
      ? 'https://status.getgorilla.app/api/uptime/healthcheck/portal-auth-eu'
      : 'https://status.getgorilla.app/api/uptime/healthcheck/portal-auth-us';

  const { data, isLoading, error } = useSWR<UptimeResponse>(
    endpoint,
    async (url: string) => {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch uptime data');
      return response.json();
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );

  return { data, isLoading, error };
}
